




























import { Component, Vue } from "vue-property-decorator";
import { orderIds } from "@/api/api.config";
@Component
export default class my_reports extends Vue {
  list: any = [];
  status = "6";
  pageNum: any = 1;
  pageCount: any = 10;
  loading = false;
  finished = false; //是否加载完成 加载完不在触发load事件
  refreshing = false; // 下拉状态
  mounted() {
    this.orderIdsList();
  }
  orderIdsList() {
    orderIds({
      status: this.status,
      page: this.pageNum,
      size: this.pageCount,
    }).then((res) => {
      this.list = res.data.content;
      if (res.data.totalPages === this.list.length) {
        this.finished = true;
      } else {
        this.finished = false;
      }
      this.pageNum++;
      this.refreshing = false;
      this.loading = false;
    });
  }

  myReport(item: any) {
    if (item.productType === 0) {
      if (item.deviceFactoryId === "zqy") {
        this.$router.push({
          path: `/bari`,
          query: {
            orderId: item.orderId,
          },
        });
      } else {
        this.$router.push({
          path: `/sgs`,
          query: {
            orderId: item.orderId,
          },
        });
      }
    } else if (item.productType === 2) {
      this.$router.push({
        path: "/online",
        query: {
          orderId: item.orderId,
        },
      });
    } else {
      window.location.href = item.lemonReportUrl;
    }
  }

  onRefresh() {
    setTimeout(() => {
      this.list = [];
      this.pageNum = 1;
      this.orderIdsList();
    }, 1000);
  }
  onLoad() {
    setTimeout(() => {
      orderIds({
        status: this.status,
        page: this.pageNum,
        size: this.pageCount,
      }).then((res) => {
        let datas = res.data.content;
        this.list = this.list.concat(datas);
        if (this.pageNum < res.data.totalPages) {
          this.pageNum++;
          this.loading = false;
        } else {
          this.finished = true;
          this.loading = true;
        }
      });
    }, 500);
  }
}
